<div class="header">
  <h3>
    {{ (newSegment ? 'coupons.segments.create' : 'coupons.segments.title') | translate }}
  </h3>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading || isStatusChange"></txp-loading>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="LoadErrorMsg"
                 *ngIf="showLoadError">
        {{ 'coupons.segments.grid.edit.loadFailMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="SaveErrorMsg"
                 *ngIf="showSaveError">
        {{ 'coupons.segments.grid.edit.saveFailMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="SaveUsersErrorMsg"
                 *ngIf="showSaveUsersError">
        {{ 'coupons.segments.grid.edit.saveUsersFailMsg' | translate }}
    </txp-message>
    <txp-message [type]="messageType.SUCCESS"
                 data-qa-label="SaveSuccessMsg"
                 *ngIf="createSegmentSuccess">
        {{ 'coupons.segments.grid.edit.saveSegmentSuccessMsg' | translate }}
    </txp-message>
</div>

<form class="form-container" *ngIf="!showLoadError && !isLoading" [formGroup]="form">
    <div class="form-content">
        <div class="form-fields">
            <mat-form-field class="name">
              <mat-label>{{ 'coupons.segments.grid.fields.name' | translate }}</mat-label>
              <input formControlName="segmentName"
                     data-qa-label="SegmentNameInput"
                     matInput
                     required />
              <mat-error>
                  {{ 'form.error.required' | translate }}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="name">
                <mat-label>{{ 'coupons.segments.grid.fields.id' | translate }}</mat-label>
                <input formControlName="id"
                       data-qa-label="SegmentIdInput"
                       matInput
                       #idInput
                       (input)="nameChanges?.unsubscribe()"
                       required />
                <mat-error>
                    {{ 'form.error.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</form>

<h3 class="users-table">{{ 'coupons.segments.grid.users.title' | translate }}</h3>

<div class="table-content">
    <table mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="onSortChange($event)"
            matSortActive="name"
            matSortDirection="asc"
            matSortDisableClear
            class="users-list">

        <ng-container matColumnDef="segmentName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'coupons.segments.grid.users.name' | translate }}</th>
        <td mat-cell *matCellDef="let user"> {{ user.firstName + ' ' + user.lastName }} </td>
        </ng-container>

        <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >{{ 'coupons.segments.grid.users.email' | translate }}</th>
        <td mat-cell *matCellDef="let user"> {{ user.email }} </td>
        </ng-container>

        <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >{{ 'coupons.segments.grid.users.id' | translate }}</th>
        <td mat-cell *matCellDef="let user"> {{ user.userId }} </td>
        </ng-container>

        <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef >{{ 'coupons.segments.grid.users.delete' | translate }}</th>
        <tr mat-cell *matCellDef="let user">
            <ng-container>
            <div class="row-actions">
                <txp-button data-qa-label="RemoveButton"
                            [disabled]="segmentsReadOnly"
                            [style]="buttonStyle.ROWACTION"
                            icon="tce-icon-trash"
                            [attr.title]="'form.button.remove' | translate"
                            (click)="deleteUser(user)">
                </txp-button>
            </div>
            </ng-container>
        </tr>
        </ng-container>

        <!-- footer for "loading" message -->
        <ng-container matColumnDef="loading">
        <td mat-footer-cell *matFooterCellDef colspan="100">
            <div>
            <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
            {{ 'coupons.segments.grid.loadingUsers' | translate }}
            </div>
        </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>

        <tr mat-footer-row *matFooterRowDef="['loading']; sticky: true" [hidden]="!usersLoading"></tr>
    </table>
</div>

    <txp-button
        [style]="buttonStyle.PRIMARY"
        [disabled]="isLoading"
        data-qa-label="AddUserButton"
        (click)="addUsers()">
        {{ 'coupons.segments.grid.users.add' | translate }}
    </txp-button>

<div class="actions">
  <txp-button
    (click)="onBack()"
    data-qa-label="BackButton"
    [style]="buttonStyle.PRIMARY">
    {{ 'form.button.back' | translate }}
  </txp-button>
  <txp-button
    [hidden]="segmentsReadOnly"
    [style]="buttonStyle.SECONDARY"
    [disabled]="isSaving || form.pristine"
    data-qa-label="CancelButton"
    (click)="onCancel()">
    {{ 'form.button.cancel' | translate }}
  </txp-button>
  <txp-button
    [hidden]="segmentsReadOnly"
    [style]="buttonStyle.PRIMARY"
    [disabled]="isSaving || form.pristine"
    [loading]="isSaving"
    data-qa-label="SaveButton"
    (click)="onSave()">
    {{ (newSegment ? 'form.button.create' : 'form.button.save') | translate }}
  </txp-button>
</div>

